import React from 'react';
import Homepage from './views/Homepage';
import Result from './views/Result';

function App() {
  return (
    <div className="App">
      <Homepage />
      <Result />
    </div>
  );
}

export default App;
